import { render } from "./IndexEdi.vue?vue&type=template&id=25b1af20"
import script from "./IndexEdi.vue?vue&type=script&lang=js"
export * from "./IndexEdi.vue?vue&type=script&lang=js"

import "./IndexEdi.vue?vue&type=style&index=0&id=25b1af20&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__